import { useEffect, useState } from 'react';
import { SchedulingByDataModel } from '../../../../../models/requests-management/workshift&Interruption';
import { RequestsManagementsAPI } from '../../../../../services/external/APIs/requests-managements/RequestsManagements';

export const CalendarController = (date: Date) => {
    const [schedulings, setSchedulings] = useState<SchedulingByDataModel[]>([]);
    const [reloading, setReloading] = useState<number>(0);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const hanlderReloading = () => {
        setReloading(reloading + 1);
    };

    useEffect(() => {
        setIsLoading(true);
        const st_date = new Date(date);
        const ed_date = date;

        st_date.setMonth(date.getMonth(), 1);
        ed_date.setMonth(ed_date.getMonth() + 1, 0);

        let startDate = st_date.toISOString();
        let endDate = date.toISOString();

        RequestsManagementsAPI.getWorkshiftSchedulingAndInterruptionsByUser({
            startDate,
            endDate,
        }).then((res: SchedulingByDataModel[]) => {
            setSchedulings(res);
            setIsLoading(false);
        });
    }, [date]);

    return { schedulings, hanlderReloading, isLoading };
};
